import { Card } from '../ui/Card';

export function Disclaimer() {
  return (
    <div className="disclaimer-block">
      Cost estimates provided by this tool are approximations only 
      and are not intended as actual price quotes. Prices are sourced 
      from the Microsoft Azure Retail Prices API and are updated 
      nightly. Actual Azure costs may vary based on the terms of your 
      Microsoft agreement, reserved instance pricing, enterprise 
      discounts, commitment plans, currency exchange rates, and 
      regional availability changes. This tool is not affiliated with, 
      endorsed by, or sponsored by Microsoft Corporation. Always verify 
      pricing through the official Azure Pricing Calculator at 
      <a 
        href="https://azure.microsoft.com/pricing/calculator" 
        target="_blank" 
        rel="noopener noreferrer"
        className="text-[#0078d4] hover:underline"
      >
        azure.microsoft.com/pricing/calculator
      </a> 
      before making purchasing decisions.
    </div>
  );
}

export function LogicAppsDisclaimer() {
  return (
    <Card variant="warning">
      <p className="text-[12px] leading-relaxed">
        NOTE: Azure Logic Apps bills each trigger check, action step, 
        retry attempt, and loop iteration as a separate execution. 
        Actual costs may differ significantly from estimates if your 
        workflows contain loops, conditions, or frequent retry scenarios.
      </p>
    </Card>
  );
}
